export const SET_CONFIG = "SET_CONFIG";
export const SET_DEVICE_ID = "SET_DEVICE_ID";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_ASSESSMENT_MODE = "SET_ASSESSMENT_MODE";
export const UPDATE_SCHOOL = "UPDATE_SCHOOL";
export const SET_CONTENT = "SET_CONTENT";
export const SET_BATTERY = "SET_BATTERY";
export const SET_BATTERY_WARN = "SET_BATTERY_WARN";
export const SET_NETWORK = "SET_NETWORK";
export const SET_NETWORK_DETAILS = "SET_NETWORK_DETAILS";
export const SET_TIME = "SET_TIME";
export const SET_LOCALE = "SET_LOCALE"
export const SET_SESSION_DETAILS = "SET_SESSION_DETAILS";
export const SET_UPDATE_PROGRESS = "SET_UPDATE_PROGRESS";
export const SET_APP_LATEST = 'SET_APP_LATEST';
export const CHECK_FOR_UPDATE = "CHECK_FOR_UPDATE";
export const SET_APP_COMPONENT_VERSIONS = "SET_APP_COMPONENT_VERSIONS";
export const SET_VIEW = "SET_VIEW";
export const SET_VALIDATION_ACTION = "SET_VALIDATION_ACTION";
export const SHOW_WARNING_ACTION = "SHOW_WARNING_ACTION";
export const SHOW_ERROR_ACTION = "SHOW_ERROR_ACTION";
export const SET_RELEASE_VERSION  = "SET_RELEASE_VERSION";
export const UPDATE_DEVICE_VALIDATION_STATE = "UPDATE_DEVICE_VALIDATION_STATE"
export const SET_ADC_VERSION = "SET_ADC_VERSION"
export const SET_SCI_VERSION = "SET_SCI_VERSION"
export const UPDATE_SERVICE_WORKER_DETAILS = "UPDATE_SERVICE_WORKER_DETAILS" 
export const UPDATE_PRECACHE_VALIDATION_STATUS = "UPDATE_PRECACHE_VALIDATION_STATUS" 
export const UPDATE_NCS_STATE = "UPDATE_NCS_STATE"
export const SET_STRESS_TEST_ACTION = "SET_STRESS_TEST_ACTION" 
export const SET_ASSESSMENT_LOCATION = "SET_ASSESSMENT_LOCATION"
export const SET_LOCATION_ERROR = "SET_LOCATION_ERROR"
export const SET_DEVICE_READINESS_SUMMARY ="SET_DEVICE_READINESS_SUMMARY"

